import React, { useState, useEffect } from "react";
import { Card, Row, Col, Typography, Divider, Space, Button, List, Spin, Modal } from "antd";
import { DownloadOutlined, EyeOutlined } from "@ant-design/icons";
import "../../../assets/dist/ConsumerProject/Consumer/ConsumerPreview.css"
import _commonService from "../../../modules/commonService";
import { useParams } from "react-router-dom";
// import CommentSection from "./CommentSection";
import _consumerService from "../../../modules/consumerService";

const { Text } = Typography;

const ApplicationDetailsTabForAdministrator = ({ activeKey }) => {
  const [applicantDetails, setApplicantDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const ApplicationObjId = params.Id;

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedDocUrl, setSelectedDocUrl] = useState('');
  const [selectedDocName, setSelectedDocName] = useState('');

  useEffect(() => {
    if (activeKey && activeKey == "2") {
      getApplicantDetailsByID(ApplicationObjId);
    }
  }, [activeKey]);

  const getApplicantDetailsByID = async (ApplicationObjId) => {
    setLoading(true);
    try {
      const res = await _consumerService.getConsumerInformationByConsumerId(ApplicationObjId);
      if (res.data) {
        let resObj = res?.data;
        setApplicantDetails(resObj);
        setLoading(false);
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const onDocumentEyeClick = (item) => {
    setSelectedDocName(item.name);
    setSelectedDocUrl(item.url);
    setIsModalVisible(true);
  };

  const onDocumentDownloadClick = (item) => {

    if (item === "Personal Financial Statement") {
      if (applicantDetails?.Cons_PFS) {
        setLoading(true);
        //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc_Personal_FinStatement_Path;
        const fileUrl = applicantDetails.Cons_PFS;
        const fileName = applicantDetails.Cons_PFS.split("/").pop();

        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setLoading(false);
      }
    } else if (item === "First 2 Pages of Federal Tax Return") {
      if (applicantDetails?.Cons_FederalTax) {
        setLoading(true);
        //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc1_Patriot_Act_Form_Applicant_Path;
        const fileUrl = applicantDetails.Cons_FederalTax;
        const fileName = applicantDetails.Cons_FederalTax.split("/").pop();

        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setLoading(false);
      }
    } else if (item == "K-1s") {
      if (applicantDetails?.Cons_K1s) {
        setLoading(true);
        //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc2_Patriot_Act_Form_CoBorrower_Path_2;
        const fileUrl = applicantDetails.Cons_K1s;
        const fileName = applicantDetails.Cons_K1s.split("/").pop();

        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setLoading(false);
      }
    } else if (item === "Fund Statements or Private Stock Evidence") {
      if (applicantDetails?.Cons_FundStatement) {
        setLoading(true);
        //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc_Credit_Breau_Report_Path;
        const fileUrl = applicantDetails.Cons_FundStatement;
        const fileName = applicantDetails.Cons_FundStatement.split("/").pop();

        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setLoading(false);
      }
    } else if (item == "Credit Bureau Report") {
      if (applicantDetails?.Cons_CreditReport) {
        setLoading(true);
        //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc3_Credit_Bureau_Report_CBR;
        const fileUrl = applicantDetails.Cons_CreditReport;
        const fileName = applicantDetails.Cons_CreditReport.split("/").pop();

        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setLoading(false);
      }
    } else {
      console.error("Unknown document type:", item);
    }
  };


  const documentMap = {
    "Personal Financial Statement": applicantDetails?.Cons_PFS,
    "First 2 Pages of Federal Tax Return": applicantDetails?.Cons_FederalTax,
    "K-1s": applicantDetails?.Cons_K1s,
    "Fund Statements or Private Stock Evidence": applicantDetails?.Cons_FundStatement,
    "Credit Bureau Report": applicantDetails?.Cons_CreditReport,
  };

  const documents = Object.entries(documentMap)
    .filter(([_, path]) => !!path)
    .map(([name, path]) => ({ name, url: path }));

  return (
    <Spin spinning={loading}>
      <Card
        className="cardViewMain mb10 application-details-card"
       
        title={
          <Row justify="space-between" align="middle">
            <Text strong>
              <span role="img" aria-label="user" style={{ marginRight: 8 }}>👤</span>
              Applicant Details
            </Text>
          </Row>
        }
      >
        <div className="">
          <Row gutter={[24, 24]}>
            <Col xs={24} md={8}>
              <Text strong>Use of Proceeds:</Text> <br />
              <Text className="b-bottm">{applicantDetails && applicantDetails.Cons_UseofProceeds || "N/A"}</Text>
            </Col>
            <Col xs={24} md={8}>
              <Text strong>Requested Loan Amount:</Text> <br />
              <Text className="b-bottm">{applicantDetails && applicantDetails.Cons_ApproximateLoanSize ?
                `$ ${_commonService.formatNumberWithCommas(applicantDetails.Cons_ApproximateLoanSize)}` : "N/A"}</Text>
            </Col>
            <Col xs={24} md={8}>
              <Text strong>Confirm Residency / Jurisdiction:</Text> <br />
              <Text className="b-bottm">{applicantDetails && applicantDetails.Cons_ConfirmResidency || "N/A"}</Text>
            </Col>
            <Col xs={24} md={8}>
              <Text strong>Application Type:</Text> <br />
              <Text className="b-bottm">{applicantDetails && applicantDetails.App_Det_Application_Type || "N/A"}</Text>
            </Col>
            <Col xs={24} md={8}>
              <Text strong>First Name:</Text> <br />
              <Text className="b-bottm">{applicantDetails && applicantDetails.App_Det_FirstName || "N/A"}</Text>
            </Col>
            <Col xs={24} md={8}>
              <Text strong>Middle Initial:</Text> <br />
              <Text className="b-bottm">{applicantDetails && applicantDetails.App_Det_MiddleInitial || "N/A"}</Text>
            </Col>
            <Col xs={24} md={8}>
              <Text type="secondary">Last Name:</Text> <br />
              <Text className="b-bottm">{applicantDetails && applicantDetails.App_Det_LastName || "N/A"}</Text>
            </Col>
            <Col xs={24} md={8}>
              <Text strong>Date Of Birth:</Text> <br />
              <Text className="b-bottm">{applicantDetails && _commonService.formatDateWithSuffixNew(applicantDetails.App_Det_DateOfBirth) || "N/A"}</Text>
            </Col>
            <Col xs={24} md={8}>
              <Text type="secondary">Email:</Text> <br />
              <Text className="b-bottm">{applicantDetails && applicantDetails.Email || "N/A"}</Text>
            </Col>
            <Col xs={24} md={8}>
              <Text type="secondary">City:</Text> <br />
              <Text className="b-bottm">{applicantDetails && applicantDetails.Ident_City || "N/A"}</Text>
            </Col>
            <Col xs={24} md={8}>
              <Text type="secondary">State:</Text> <br />
              <Text className="b-bottm">{applicantDetails && applicantDetails.Ident_State || "N/A"}</Text>
            </Col>
            <Col xs={24} md={8}>
              <Text type="secondary">Zip Code:</Text> <br />
              <Text className="b-bottm">{applicantDetails && applicantDetails.Ident_ZipCode || "N/A"}</Text>
            </Col>
            <Col xs={24} md={8}>
              <Text type="secondary">Employer Name:</Text> <br />
              <Text className="b-bottm">{applicantDetails && applicantDetails.Prof_Employer_Name || "N/A"}</Text>
            </Col>
            <Col xs={24} md={8}>
              <Text type="secondary">Position/Title:</Text> <br />
              <Text className="b-bottm">{applicantDetails && applicantDetails.Prof_JobRole || "N/A"}</Text>
            </Col>
            <Col xs={24} md={8}>
              <Text type="secondary">Number of Years with Employer:</Text> <br />
              <Text className="b-bottm">{applicantDetails && applicantDetails.Prof_NO_Years || "N/A"}</Text>
            </Col>
          </Row>
          {/* <CommentSection CommentSectionName="aapplicationidentification" applicationstatusid={applicantDetails.Application_Status_Id} /> */}
        </div>
      </Card>

      {documents && documents.length > 0 &&
        <Card
          // style={{ borderRadius: 16 }}
          // bodyStyle={{ padding: 0 }}
          className="cardViewMain application-details-card"
          title={
            <Row justify="space-between" align="middle">
              <Text strong>
                <span role="img" aria-label="user" style={{ marginRight: 8 }}>🧾</span>
                Documents
              </Text>
            </Row>
          }
        >
          <div className="DocuementListAdministrator">
            <List
              dataSource={documents}
              renderItem={(item, index) => (
                <List.Item
                  style={{
                    
                    // backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff",
                    borderBottom: index === documents.length - 1 ? "none" : "1px solid #2e2f30",
                  }}
                  actions={[
                    // <Button icon={<EyeOutlined />} type="text" key="view" onClick={() => onDocumentEyeClick(item)} />,
                    <Button className="iconColor" icon={<DownloadOutlined />} type="text" key="download" onClick={() => onDocumentDownloadClick(item.name)} />,
                  ]}>
                  <Space size="middle">
                    <Text strong style={{ width: 24 }}>{`0${index + 1}.`}</Text>
                    <Text>{item.name}</Text>
                  </Space>
                </List.Item>
              )}
            />
            {/* <Divider />
            <Col span={4}>
              <Text type="secondary">CBR Score:</Text> <br />
              <Text className="b-bottm">{applicantDetails && applicantDetails.CBRScore}</Text>
            </Col> */}
            {/* <CommentSection CommentSectionName="personalfinancialstatement" applicationstatusid={applicantDetails.Application_Status_Id} /> */}
          </div>
        </Card>
      }

      <Modal
        open={isModalVisible}
        title={selectedDocName}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        width="80vw" // Wider
        bodyStyle={{ height: '80vh', padding: 0 }} // Taller
        destroyOnClose
      >
        <iframe
          src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedDocUrl)}&embedded=true`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          title={selectedDocName}
        />
      </Modal>
    </Spin>
  )
}
export default ApplicationDetailsTabForAdministrator;